module.exports = __webpack_public_path__ + "th.svg?86821b8cd58474bce4bfb5baeaae7cec";